import React from 'react';
import { Route } from 'react-router-dom';
import Home from '../app/Home';
import AdminApp from '../AdminApp';
import Reference from '../app/references';
import ResetPassword from '../ResetPassword';
import ChangePassword from '../ChangePassword';
import { appPath } from '../../constants/index';

const MainRouts = () => (
  <React.Fragment>
    <Route exact path='/' component={Home} />
    <Route path={`/${appPath}`} component={AdminApp} />
    <Route path='/income-reference' component={Reference} />
    <Route path='/reset-password' component={ResetPassword} />
    <Route path='/change-password' component={ChangePassword} />
  </React.Fragment>
);

export default MainRouts;



// WEBPACK FOOTER //
// ./src/components/router/MainRouts.js